import { chakra, Table, TableContainer, Tbody, Td, Th, Thead, Tr } from '@chakra-ui/react';
import LoaderOverlay from '@/features/common/LoaderOverlay.jsx';
import PropTypes from 'prop-types';

const SingleRowTable = ({ headers, data, bgColor = 'white', ...props }) => {
  return (
    <TableContainer border={'1px solid'} borderColor="gray.100" borderRadius="md" {...props}>
      <LoaderOverlay loading={!data} />
      <Table variant={'simple'} maxWidth={'100%'}>
        <Thead>
          <Tr>
            {headers?.map((val, i) => (
              <Th key={i} style={{ minWidth: '100px' }} textAlign={'left'}>
                <chakra.span>{val}</chakra.span>
              </Th>
            ))}
          </Tr>
        </Thead>
        <Tbody>
          <Tr bgColor={bgColor}>
            {data?.map((val, i) => (
              <Td key={i} style={{ whiteSpace: 'break-spaces', wordWrap: 'break-word', height: '1px' }}>
                {val}
              </Td>
            ))}
          </Tr>
        </Tbody>
      </Table>
    </TableContainer>
  );
};
SingleRowTable.propTypes = {
  headers: PropTypes.array,
  data: PropTypes.array,
};
export default SingleRowTable;
